import React, { Component } from 'react';
import Select from 'react-select';
import styled from 'styled-components';

const Dimension = [
    { label: "processing", value: 1 },
    { label: "backup", value: 2 },
];
const customStyles = {
    control: (provided, state) => ({
        ...provided,
        background: '#fff',
        borderColor: '#9e9e9e',
        minHeight: '35px',
        height: '35px',
    }),

    valueContainer: (provided, state) => ({
        ...provided,
        height: '40px',
        padding: '0 6px'
    }),

    indicatorSeparator: state => ({
        display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
        ...provided,
        height: '30px',
    }),
};

class DimensionDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedDimension: '',
            dimensions: [],
        }
        this.state.formHide = { visibility: this.props.name ? 'visible' : 'hidden' }
    }

    componentDidUpdate(prevProps) {
        if (this.props.dimensions !== prevProps.dimensions) {
            const { dimensions } = this.props;
            if (dimensions) {
                let dimension = dimensions.map(e => { return { label: e.label, value: e } })
                this.setState({ dimensions: dimension, selectedDimension: dimension[0] });
                this.handleChange(dimension[0])
            }
        }
    }
    handleChange(selectedDimension) {
        this.props.dropDownSelected(selectedDimension.value);
        this.setState({
            selectedDimension: selectedDimension
        })
    }

    render() {
        return (
            <Container>
                <p>Select a dimension</p>
                <Select
                    className="form-container"
                    classNamePrefix="select"
                    label="Single select"
                    options={this.state.dimensions}
                    styles={customStyles}
                    onChange={this.handleChange.bind(this)}
                    value={this.state.selectedDimension}
                />
            </Container>
        )
    }

}

export default DimensionDropDown;

const Container = styled.div`
    flex-grow: 1;
    p {
        font-size: 15px;
        font-weight: 500;
        margin-left: 16px;
        margin-bottom: 5px;
        font-family: RobotoMedium;
    }
    .select__control {
        background-color: #f8f8f8;
        border-radius: unset;
        color: #B2B3B7 !important;
        border-color: #B2B3B7 !important;
        height: auto;
        padding: 10px 12px;
    }
    .select__input {
        color: transparent;
    }
    .select__value-container {
        height: auto;
        font-size: 16px;
    }
    .select__single-value {
        color: #0A0E17;
    }
    .select__indicator {
        color: #0A0E17;
    }
`;